var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{ref:"chartDom",staticClass:"bar",staticStyle:{"width":"600px","height":"600px","border":"2px solid red"},attrs:{"id":"chartOne"}})])}
var staticRenderFns = []

export { render, staticRenderFns }